import { render, staticRenderFns } from "./agent-setup.vue?vue&type=template&id=53264f59&scoped=true&"
import script from "./agent-setup.vue?vue&type=script&lang=ts&"
export * from "./agent-setup.vue?vue&type=script&lang=ts&"
import style0 from "./agent-setup.vue?vue&type=style&index=0&id=53264f59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53264f59",
  null
  
)

export default component.exports